import React, { useState } from "react";
import spatiallogo from "../components/assets/spatiallogo.svg";
import {
  FaBook,
  FaUsers,
  FaSignOutAlt,
  FaChartBar,
  FaFire,
  FaHeartbeat,
  FaMousePointer,
  FaBars,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Sidebar() {
  const [isExpanded, setIsExpanded] = useState(true);
  const navigate = useNavigate();

  const toggleSidebar = () => setIsExpanded(!isExpanded);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userData");
    navigate("/Login");
  };

  const navItems = [
    { icon: FaBook, text: "Library", path: "/library" },
    { icon: FaChartBar, text: "Heatmaps", path: "/dashboard/analytics" },
    { icon: FaFire, text: "Engagement", path: "/dashboard/engagement" },
    {
      icon: FaHeartbeat,
      text: "Behavior Metrics",
      path: "/dashboard/behavior-metrics",
    },
    {
      icon: FaMousePointer,
      text: "Interactions",
      path: "/dashboard/interaction-metrics",
    },
    { icon: FaUsers, text: "Users", path: "/users" },
  ];

  return (
    <div
      className={`flex flex-col h-screen bg-[#1e1f22] text-white transition-all duration-300 ${
        isExpanded ? "w-60" : "w-20"
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-4 border-b border-[#444447]">
        {isExpanded && (
          <img src={spatiallogo} className="h-8 w-auto" alt="Spatial Logo" />
        )}

        <button
          className={`text-white hover:text-gray-300 transition ${
            !isExpanded ? "mx-auto" : ""
          }`}
          onClick={toggleSidebar}
        >
          <FaBars className="text-xl" />
        </button>
      </div>

      {/* Nav Items */}
      <nav className="flex-1">
        {navItems.map((item, index) => {
          const Icon = item.icon;

          return (
            <div
              key={index}
              className="relative group flex items-center gap-4 px-6 py-4 cursor-pointer hover:bg-[#333334] transition-colors border-b border-[#444447]"
              onClick={() => navigate(item.path)}
            >
              <Icon className="text-xl min-w-[20px]" />

              {isExpanded && <span className="text-sm">{item.text}</span>}

              {/* Tooltip */}
              {!isExpanded && (
                <span className="absolute left-full ml-3 px-3 py-1 text-xs bg-[#111] text-white rounded-md shadow-lg opacity-0 translate-x-2 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-200 whitespace-nowrap z-50">
                  {item.text}
                </span>
              )}
            </div>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="border-t border-[#444447]">
        <div
          className="relative group flex items-center gap-4 px-6 py-4 cursor-pointer hover:bg-[#333334] transition-colors"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="text-xl min-w-[20px]" />

          {isExpanded && <span className="text-sm">Log out</span>}

          {/* Tooltip */}
          {!isExpanded && (
            <span className="absolute left-full ml-3 px-3 py-1 text-xs bg-[#111] text-white rounded-md shadow-lg opacity-0 translate-x-2 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-200 whitespace-nowrap z-50">
              Log out
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
